import {
  useABStore,
  useAuthStore,
  useBonusesStore,
  useFreeGameStore,
  useGameOnboardingStore,
  useLocationTabsStore,
  useNavigationModalStore,
  useNotificationsStore,
  useOnboardingModalStore,
  usePassportStore,
  usePollStore,
  usePrizeStore,
  useProgressUpdateRewardsStore,
  useShareStore,
  useShowCaseModalStore,
  useStoreItemsStore,
  useTasksStore,
  useTimerStore,
  useUserBoostersStore,
  useUserEnergyStore,
  useUserStore,
} from '@/di/di.root-container.hooks';

import {useSyncExternalStore} from 'react';

import {ABStore} from '@/stores/ABStore/ABStore';
import {AuthStore} from '@/stores/AuthStore/AuthStore';
import {BonusesStore} from '@/stores/BonusesStore/BonusesStore';
import {GameOnboardingStore} from '@/stores/GameOnboardingStore/GameOnboardingStore';
import {LocationTabsStore} from '@/stores/LocationTabsStore/LocationTabsStore';
import {NavigationModalStore} from '@/stores/NavigationModalStore/NavigationModalStore';
import {OnboardingModalStore} from '@/stores/OnboardingModalStore/OnboardingModalStore';
import {PassportStore} from '@/stores/PassportStore/PassportStore';
import {PollStore} from '@/stores/PollStore/PollStore';
import {PrizeStore} from '@/stores/PrizeStore/PrizeStore';
import {ProgressUpdateRewardsStore} from '@/stores/ProgressUpdateRewardsStore/ProgressUpdateRewardsStore';
import {ShareStore} from '@/stores/ShareStore/ShareStore';
import {ShowCaseModalStore} from '@/stores/ShowCaseModalStore/ShowCaseModalStore';
import {StoreItemsStore} from '@/stores/StoreItemsStore/StoreItemsStore';
import {TasksStore} from '@/stores/TasksStore/TasksStore';
import {TimerStore} from '@/stores/TimerStore/TimerStore';
import {FreeGameStore} from '@/stores/UserStore/FreeGameStore';
import {NotificationsStore} from '@/stores/UserStore/NotificationsStore';
import {UserBoostersStore} from '@/stores/UserStore/UserBoostersStore';
import {UserEnergyStore} from '@/stores/UserStore/UserEnergyStore';
import {UserStore} from '@/stores/UserStore/UserStore';

export function useObservedUserStore(): UserStore {
  const userStore = useUserStore();
  useSyncExternalStore(userStore.subscribe, userStore.getState);

  return userStore;
}

export function useObservedABStore(): ABStore {
  const abStore = useABStore();
  useSyncExternalStore(abStore.subscribe, abStore.getState);

  return abStore;
}

export function useObservedAuthStore(): AuthStore {
  const authStore = useAuthStore();
  useSyncExternalStore(authStore.subscribe, authStore.getState);

  return authStore;
}

export function useObservedNavigationModalStore(): NavigationModalStore {
  const navigationModalStore = useNavigationModalStore();
  useSyncExternalStore(navigationModalStore.subscribe, navigationModalStore.getState);

  return navigationModalStore;
}

export function useObservedTimerStore(): TimerStore {
  const timerStore = useTimerStore();
  useSyncExternalStore(timerStore.subscribe, timerStore.getState);

  return timerStore;
}

export function useObservedUserEnergyStore(): UserEnergyStore {
  const userEnergyStore = useUserEnergyStore();
  useSyncExternalStore(userEnergyStore.subscribe, userEnergyStore.getState);

  return userEnergyStore;
}

export function useObservedBonusesStore(): BonusesStore {
  const bonusesStore = useBonusesStore();
  useSyncExternalStore(bonusesStore.subscribe, bonusesStore.getState);

  return bonusesStore;
}

export function useObservedUserBoostersStore(): UserBoostersStore {
  const userBoostersStore = useUserBoostersStore();
  useSyncExternalStore(userBoostersStore.subscribe, userBoostersStore.getState);

  return userBoostersStore;
}

export function useObservedTasksStore(): TasksStore {
  const tasksStore = useTasksStore();
  useSyncExternalStore(tasksStore.subscribe, tasksStore.getState);

  return tasksStore;
}

export function useObservedPassportStore(): PassportStore {
  const passportStore = usePassportStore();
  useSyncExternalStore(passportStore.subscribe, passportStore.getState);

  return passportStore;
}

export function useObservedNotificationsStoreStore(): NotificationsStore {
  const notificationsStore = useNotificationsStore();
  useSyncExternalStore(notificationsStore.subscribe, notificationsStore.getState);

  return notificationsStore;
}

export function useObservedShareStore(): ShareStore {
  const shareStore = useShareStore();
  useSyncExternalStore(shareStore.subscribe, shareStore.getState);

  return shareStore;
}

export function useObservedStoreItemsStore(): StoreItemsStore {
  const storeItemsStore = useStoreItemsStore();
  useSyncExternalStore(storeItemsStore.subscribe, storeItemsStore.getState);

  return storeItemsStore;
}

export function useObservedLocationTabsStore(): LocationTabsStore {
  const locationTabsStore = useLocationTabsStore();
  useSyncExternalStore(locationTabsStore.subscribe, locationTabsStore.getState);

  return locationTabsStore;
}

export function useObservedOnboardingModalStore(): OnboardingModalStore {
  const onboardingModalStore = useOnboardingModalStore();
  useSyncExternalStore(onboardingModalStore.subscribe, onboardingModalStore.getState);

  return onboardingModalStore;
}

export function useObservedGameOnboardingStore(): GameOnboardingStore {
  const gameOnboardingStore = useGameOnboardingStore();
  useSyncExternalStore(gameOnboardingStore.subscribe, gameOnboardingStore.getState);

  return gameOnboardingStore;
}

export function useObservedProgressUpdateRewardsStore(): ProgressUpdateRewardsStore {
  const progressUpdateRewardsStore = useProgressUpdateRewardsStore();
  useSyncExternalStore(progressUpdateRewardsStore.subscribe, progressUpdateRewardsStore.getState);

  return progressUpdateRewardsStore;
}

export function useObservedShowCaseModalStore(): ShowCaseModalStore {
  const showCaseModalStore = useShowCaseModalStore();
  useSyncExternalStore(showCaseModalStore.subscribe, showCaseModalStore.getState);

  return showCaseModalStore;
}

export function useObservedPrizeStore(): PrizeStore {
  const prizeStore = usePrizeStore();
  useSyncExternalStore(prizeStore.subscribe, prizeStore.getState);

  return prizeStore;
}

export function useObservedPollStore(): PollStore {
  const pollStore = usePollStore();
  useSyncExternalStore(pollStore.subscribe, pollStore.getState);

  return pollStore;
}

export function useObservedFreeGameStore(): FreeGameStore {
  const freeGameStore = useFreeGameStore();
  useSyncExternalStore(freeGameStore.subscribe, freeGameStore.getState);

  return freeGameStore;
}
